import React from "react";
import { useNavigate } from "react-router-dom";
import { SubNavigation } from "./SubNavigation";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { hasCorePlatformAccess } from "@/utils/accessControl";

interface ReservationNavigationProps {
  activeTab: "reservations" | "guests" | "rooms";
}

export const ReservationNavigation: React.FC<ReservationNavigationProps> = ({
  activeTab,
}) => {
  const navigate = useNavigate();
  const { userProfile } = useAuthenticatedUser();

  if (!hasCorePlatformAccess(userProfile, "reservations")) {
    return null;
  }

  const navigationItems = [
    { label: "Reservations", path: "/reservations", id: "reservations" },
    { label: "Guests", path: "/reservations/guests", id: "guests" },
    { label: "Rooms", path: "/reservations/rooms", id: "rooms" },
  ];

  const handleTabChange = (tabId: string) => {
    const item = navigationItems.find((item) => item.id === tabId);
    if (item) {
      navigate(item.path);
    }
  };

  return (
    <SubNavigation
      activeTab={activeTab}
      onTabChange={handleTabChange}
      tabs={navigationItems}
    />
  );
};
